/*
         * @ngdoc function
         * @name ePay.Model:SettingsModel
         * @description
         * Model
         */

export class SettingsModel {
  amount: string | null | undefined;
  storeonly: string | null | undefined;
  is_redirect: string | null | undefined;
  checking_ach: string | null | undefined;
  creditCard_saveLater: string | null | undefined;

	constructor(
		amount?: string, 
		storeonly?: string, 
		is_redirect?: string, 
		checking_ach?: string, 
		creditCard_saveLater?: string
	) {
		this.amount = amount || null;
		this.storeonly = storeonly || null;
		this.is_redirect = is_redirect || null;
		this.checking_ach = checking_ach || null;
		this.creditCard_saveLater = creditCard_saveLater || null;
	}
}
